
import './SendNote.css';
import React, {useState} from "react";

function SendNote(props) {
    const [sendTo, setSendTo] = useState("[send to]")
    const [sendMessage, setSendMessage] = useState("[add message here]")
    const [sendFrom, setSendFrom] = useState("[sent from]")

    function clearData() {
        setSendTo("")
        setSendFrom("")
        setSendMessage("")
    }

    return (
        <div>
            <div className="noteDiv">
                <div className="noteImageDiv">
                <img className="bouquetImageOnNote" alt={props.selectedBouquet.alt} src={props.selectedBouquet.src}/>
                </div>
                <p className="noteText sendToText"> {sendTo}</p>
                <p className="noteText messageText"> {sendMessage} </p>
                <p className="noteText sentFromText"> {sendFrom}</p>
            </div>
            {props.type==="prebuilt" && 
                <p onClick={() => {props.setSelectedBouquet(null)}}> back to bouquet selection</p>
            }
            {props.type==="custom" && 
                <p onClick={() => {clearData()}}> back to bouquet arrangement</p>
            }
            
        </div>
    )
}

export default SendNote;